import Types from "./Types";

export const BookingsLoading = (payload) => ({
  type: Types.BOOKINGS_LOADING,
  payload,
});

export const GetBookingsSuccess = (payload) => ({
  type: Types.GET_BOOKINGS_SUCCESS,
  payload,
});

export const GetBookingDetailsSuccess = (payload) => ({
  type: Types.GET_BOOKING_DETAILS_SUCCESS,
  payload,
});
